import { useEffect, useRef } from 'react'
import { Fancybox as NativeFancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

function Fancybox(props) {
	const containerRef = useRef(null)

	useEffect(() => {
		const container = containerRef.current

		const delegate = props.delegate || '[data-fancybox]'
		const options = props.options || {}

		NativeFancybox.bind(container, delegate, options)

		return () => {
			NativeFancybox.unbind(container)
			NativeFancybox.close()
		}
	}, [])

	return (
		<div
			ref={containerRef}
			className="relative w-full h-full flex-shrink-0 flex justify-center items-center overflow-hidden"
		>
			{/* Блюреный фон */}
			{props.bgImage && (
				<div
					className="absolute inset-0 bg-cover bg-center filter blur-2xl scale-110"
					style={{
						backgroundImage: `url(${props.bgImage})`,
						zIndex: 0,
					}}
				/>
			)}

			{/* Контент поверх */}
			<div className="relative z-10 w-full h-full flex justify-center items-center">
				{props.children}
			</div>
		</div>
	)
}

export default Fancybox
